// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="\$ctrl.description"></sub-header>

  <div class="input-prepend select-branch">
    <label for="filter-branch" class="add-on">Move user to branch</label>
    <select id="filter-branch"
            required
            ng-disabled="!\$ctrl.branches"
            ng-model="\$ctrl.commandRequest.targetBranchId"
            ng-options="entry.id as entry.name for entry in \$ctrl.branches"
    >
    </select>
  </div>
  <div class="buttons">
    <button class="btn btn-warning"
            type="button"
            ng-click="\$ctrl.cancelChanges()">
      Cancel
    </button>
    <button class="btn btn-primary"
            type="button"
            ng-disabled="!\$ctrl.commandRequest.targetBranchId"
            ng-click="\$ctrl.changeBranch()">
      Move user to branch
    </button>
  </div>
</div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/users/change-branch/users-change-branch.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;